import { TabInterface } from "components/layout/interfaces";
import Tabs from "components/layout/tabs";
import View from "components/layout/view";
import Title from "components/title";
import SecurityTab from "./tabs/security/security-tab";
import BaseTab from "./tabs/base/base-tab";

const AdminProfileView = () => {
  const title = "Oma tili";

  const tabs: TabInterface[] = [
    { key: "base", label: "Omat tiedot", render: () => <BaseTab /> },
    { key: "security", label: "Tietoturva", render: () => <SecurityTab /> },
  ];
  return (
    <View title={title} description="">
      <Title>{title}</Title>
      <Tabs name="profile" tabs={tabs} />
    </View>
  );
};

export default AdminProfileView;
